import * as yup from 'yup';
import { FIELD_TYPE_VALIDATION } from 'Helpers/validations';
import { maxNumber } from 'Helpers/validations/validations.helpers';
import { HIERARCHY_LABEL_GROUP_VALUES } from 'app-config';

const baseSchema = (maxGroupNameAmountCharacters: number) =>
	yup.object().shape({
		levelName: FIELD_TYPE_VALIDATION.text
			.label('groupsHierarchy.formXLSX.levelItem.name')
			.min(2)
			.max(maxGroupNameAmountCharacters),
		numberOfGroups: FIELD_TYPE_VALIDATION.numeric
			.label('groupsHierarchy.formXLSX.levelItem.numberOfGroups')
			.max(3, (params) => maxNumber({ ...params, max: 999 })),
		hierarchyLabel: yup
			.string()
			.label('Type')
			.required('Type is required')
			.oneOf(
				HIERARCHY_LABEL_GROUP_VALUES as unknown as string[],
				'Please select a valid type'
			)
	});

const schema = (maxGroupNameAmountCharacters: number) =>
	yup.object().shape({
		levels: yup.array().of(baseSchema(maxGroupNameAmountCharacters))
	});

export default schema;
